import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "@/components/ui/button";

export const ProfessionalPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const accepted = sessionStorage.getItem("professional-accepted");
    if (!accepted) {
      setIsOpen(true);
    }
  }, []);

  const handleAccept = () => {
    sessionStorage.setItem("professional-accepted", "true");
    setIsOpen(false);
  };

  const handleDecline = () => {
    window.location.href = "https://grupaq.pl/";
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Overlay */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 z-[999] bg-black/50 dark:bg-black/70 backdrop-blur-sm"
            data-testid="professional-popup-overlay"
          />

          {/* Dialog */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 z-[1000] flex items-center justify-center p-4"
            data-testid="professional-popup"
          >
            <div className="w-full max-w-lg rounded-xl bg-white dark:bg-[#171A1F] border border-gray-200 dark:border-white/10 p-8 shadow-2xl">
              <h2 className="text-xl font-bold text-[#212738] dark:text-white">
                Witamy na stronie firmy CKK ResQ
              </h2>

              <p className="mt-4 text-[#504D4D] dark:text-white/70 text-sm leading-relaxed">
                Strona zawiera treści wyłącznie dla osób, które stosują wyroby medyczne jako profesjonaliści lub wykonujących zawody medyczne.
              </p>

              <p className="mt-3 text-[#212738] dark:text-white/80 text-sm">
                Jesteś taką osobą? Kliknij "TAK" i zapoznaj się z treścią strony.
              </p>

              <div className="mt-6 flex items-center gap-3">
                <Button
                  onClick={handleAccept}
                  className="bg-[#EA8628] hover:bg-[#d4791f] text-white font-semibold px-8 py-5"
                  data-testid="professional-popup-accept-btn"
                >
                  TAK
                </Button>
                <Button
                  onClick={handleDecline}
                  variant="outline"
                  className="border-gray-300 dark:border-white/20 text-[#504D4D] dark:text-white/80 hover:bg-gray-100 dark:hover:bg-white/10 hover:text-[#212738] dark:hover:text-white font-semibold px-8 py-5"
                  data-testid="professional-popup-decline-btn"
                >
                  NIE
                </Button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};
